<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import Routes from '@/constants/Routes';
import { DxButton } from 'devextreme-vue/button';
import { DxTextBox } from 'devextreme-vue/text-box';
import SubmitButtonContent from '@/components/devextreme/SubmitButtonContent.vue';
import Icons from '@/constants/Icons';
import BootstrapAlert from '@/components/bootstrap/BootstrapAlert.vue';
import BootstrapCard from '@/components/bootstrap/BootstrapCard.vue';
import { useAccountService } from '@/services/api/accountService';

definePage({ name: 'AccountMfaReset', meta: { title: 'account.resetAppTitle' } });

const account = useAccountService();
const router = useRouter();
const loading = ref<boolean>(false);
const currentPassword = ref('');

async function resetMfa(): Promise<void> {
  loading.value = true;
  const success = await account.resetMfa(currentPassword.value);
  if (success) {
    await router.push({ name: Routes.Account.MfaEnable });
  } else {
    loading.value = false;
  }
}
</script>

<template>
  <BootstrapCard :header-text="$t('account.resetAppTitle')">
    <BootstrapAlert :type="'warning'">
      <p>{{ $t('account.resetAppWarning') }}</p>
      <p class="mb-0">{{ $t('account.resetAppLoseAccess') }}</p>
    </BootstrapAlert>

    <form @submit.prevent="resetMfa">
      <DxTextBox v-model:value="currentPassword" mode="password" :label="$t('labels.currentPassword')" label-mode="floating"
          :disabled="loading" class="mt-3" />
      <DxButton type="warning" :use-submit-behavior="true" class="my-3" :disabled="loading || !currentPassword">
        <SubmitButtonContent :loading="loading" :icon="Icons.Recycle" :text="$t('account.resetKeyButton')" />
      </DxButton>
    </form>
  </BootstrapCard>
</template>

<style scoped>

</style>